import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  // Menünün açık/kapalı durumunu tutan state
  const [isOpen, setIsOpen] = useState(false);

  // Menü durumunu tersine çeviren fonksiyon
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Linke tıklandığında menüyü otomatik kapatan fonksiyon
  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow-sm">
      <div className="container">
        {/* LOGO / FİRMA ADI */}
        <Link className="navbar-brand fw-bold fs-4" to="/" onClick={closeMenu}>
          DMNGL Nakliyat
        </Link>

        {/* MOBİL ÜÇ ÇİZGİ (TOGGLER) BUTONU */}
        <button
          className="navbar-toggler border-0 focus-ring-none"
          type="button"
          onClick={toggleMenu}
          aria-expanded={isOpen}
          aria-label="Navigasyonu Aç/Kapat"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENÜ LİNKLERİ (STATE'E GÖRE AÇILIP KAPANIR) */}
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 py-2 py-lg-0">
            <li className="nav-item">
              <Link className="nav-link text-white fw-semibold" to="/" onClick={closeMenu}>
                Ana Sayfa
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link text-white fw-semibold" href="#hizmetlerimiz" onClick={closeMenu}>
                Hizmetlerimiz
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-white fw-semibold" to="/hakkimizda" onClick={closeMenu}>
                Hakkımızda
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link text-white fw-semibold" href="#yorumlar" onClick={closeMenu}>
                Yorumlar
              </a>
            </li>
            <li className="nav-item ms-lg-2 mt-2 mt-lg-0">
              <a href="tel:05352439955" className="btn btn-primary fw-bold w-100" onClick={closeMenu}>
                📞 0535 243 99 55
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;